import { collection, doc, getDoc, setDoc, deleteDoc } from 'firebase/firestore';
import { db } from '../config/firebase';
import type { Channel } from '../types';
import { auth } from '../config/firebase';

export const useFirestore = () => {
  const loadPlaylist = async (userId: string | null): Promise<Channel[]> => {
    // console.log('Loading playlist');

    if (!userId || !auth.currentUser) {
      // console.log('No user authenticated, returning empty playlist');
      return [];
    }

    try {
      const docRef = doc(db, 'channels', userId);
      // console.log('Reading document');
      
      // Try to read first
      const docSnap = await getDoc(docRef);
      // console.log('Document read completed');
      
      if (docSnap.exists()) {
        const data = docSnap.data();
        // console.log('Document data loaded');
        return data.channels || [];
      }
      
      // If document doesn't exist, create it with empty channels
      // console.log('Creating new document');
      try {
        await setDoc(docRef, { 
          channels: [],
          createdAt: new Date().toISOString(),
          userId
        });
        // console.log('Initial document created');
      } catch (error) {
        // console.error('Document creation error');
      }
      
      return [];
    } catch (error) {
      // console.error('Error loading playlist');
      return [];
    }
  };

  const savePlaylist = async (userId: string | null, channels: Channel[]): Promise<void> => {
    // console.log('Saving playlist');

    if (!userId || !auth.currentUser) {
      // console.log('No user authenticated, skipping save');
      return;
    }

    try {
      const docRef = doc(db, 'channels', userId);
      const data = { 
        channels,
        updatedAt: new Date().toISOString(),
        userId
      };
      
      // console.log('Saving data');
      await setDoc(docRef, data);
      // console.log('Playlist saved successfully');
    } catch (error) {
      // console.error('Error saving playlist');
      throw new Error('Failed to save playlist');
    }
  };

  const deletePlaylist = async (userId: string | null): Promise<void> => {
    // console.log('Deleting playlist');

    if (!userId || !auth.currentUser) {
      // console.log('No user authenticated, skipping delete');
      return;
    }

    try {
      const docRef = doc(db, 'channels', userId);
      await deleteDoc(docRef);
      // console.log('Playlist deleted successfully');
    } catch (error) {
      // console.error('Error deleting playlist');
      throw new Error('Failed to delete playlist');
    }
  };

  return {
    loadPlaylist,
    savePlaylist,
    deletePlaylist,
  };
}; 